var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_984_8524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#paint0_linear_984_8524)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_984_8524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0012 13.2904C8.4365 13.2904 7.15631 12.0102 7.15631 10.4455C7.15631 8.88085 8.4365 7.60067 10.0012 7.60067C11.5658 7.60067 12.846 8.88085 12.846 10.4455C12.846 12.0102 11.5658 13.2904 10.0012 13.2904ZM10.0012 8.31188C8.82767 8.31188 7.86753 9.27202 7.86753 10.4455C7.86753 11.619 8.82767 12.5792 10.0012 12.5792C11.1747 12.5792 12.1348 11.619 12.1348 10.4455C12.1348 9.27202 11.1747 8.31188 10.0012 8.31188ZM17.8957 10.6945L16.3666 12.2413C14.6774 13.9483 12.4193 14.8906 10.0012 14.8906C7.58304 14.8906 5.32493 13.9483 3.6358 12.2413L2.10668 10.6945C1.96444 10.5522 1.96444 10.3388 2.10668 10.1966L3.6358 8.64971C5.32493 6.94279 7.58304 6.00043 10.0012 6.00043C12.4193 6.00043 14.6774 6.94279 16.3666 8.64971L17.8957 10.1966C18.0379 10.3388 18.0379 10.5522 17.8957 10.6945ZM15.8687 9.14756C14.304 7.58289 12.2237 6.71165 10.0012 6.71165C7.77863 6.71165 5.69832 7.58289 4.13365 9.14756L2.85346 10.4455L4.13365 11.7435C5.69832 13.3082 7.77863 14.1794 10.0012 14.1794C12.2237 14.1794 14.304 13.3082 15.8687 11.7435L17.1489 10.4455L15.8687 9.14756Z",
    fill: "url(#paint1_linear_984_8524)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_8524",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281054,
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_8524",
    x1: 10.0012,
    y1: 6.00043,
    x2: 10.0012,
    y2: 14.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiView);
export default __webpack_public_path__ + "static/media/gi_view.8d1d5a52920ff17bd555313fec9db28e.svg";
export { ForwardRef as ReactComponent };